import { useSyncExternalStore } from "react";

// Lightweight external store so the 3D scene can read stress values inside
// useFrame WITHOUT re-rendering the Canvas tree on every slider drag.
const state = {
  phd: 0.15, // PhD Production Rate      0..1
  budget: 0.1, // Budget Contraction     0..1
  funding: 0.1, // Funding Cuts          0..1
  audioReady: false,
};

const listeners = new Set();

function emit() {
  for (const l of listeners) l();
}

export const stressStore = {
  getState: () => state,
  get: (key) => state[key],
  set: (patch) => {
    Object.assign(state, patch);
    emit();
  },
  subscribe: (l) => {
    listeners.add(l);
    return () => listeners.delete(l);
  },
};

let _userTick = 0;
// Called for direct human interaction (sliders) so an in-progress
// Collapse animation can detect the override and bail out.
stressStore.setUser = (patch) => {
  _userTick += 1;
  stressStore.set(patch);
};
stressStore.userTick = () => _userTick;

// crisis 0..1 — weighted blend of the three pressures
export function crisisLevel(s = state) {
  return Math.min(1, s.phd * 0.35 + s.budget * 0.3 + s.funding * 0.35);
}

// React hook for DOM components (HUD) to read a slice reactively.
export function useStress(selector) {
  return useSyncExternalStore(
    stressStore.subscribe,
    () => selector(stressStore.getState()),
    () => selector(stressStore.getState())
  );
}
